;(function () {
  angular
    .module('contrast.thermometer')
    .directive('thermometerChart', function () {
      return {
        restrict: 'E',
        scope: {
          max: '=',
          values: '=',
          message: '=',
          sectionClick: '&',
          tooltipTemplate: '=?',
          tooltipClass: '@',
          tooltipPlacement: '@'
        },
        templateUrl: 'components/thermometer/thermometer-chart.html',
        link: function ($scope) {
          var template = $scope.tooltipTemplate,
            tooltipClass = $scope.tooltipClass,
            tooltipPlacement = $scope.tooltipPlacement
          if (angular.isUndefined(template)) {
            $scope.template = "'views/tooltips/thermometerTooltip.html'"
          } else if (template) {
            $scope.template = "'" + template + "'"
          }
          if (angular.isUndefined(tooltipClass)) {
            $scope.tooltipClass = ''
          } else {
            $scope.tooltipClass = tooltipClass
          }
          if (angular.isUndefined(tooltipPlacement)) {
            $scope.tooltipPlacement = 'bottom'
          } else {
            $scope.tooltipPlacement = tooltipPlacement
          }

          var ratioTotal = 100

          function recalculateData() {
            var total = $scope.values.count
            var ratio = total / ratioTotal

            if ($scope.values && $scope.values.data) {
              for (var i = 0; i < $scope.values.data.length; i++) {
                var datum = $scope.values.data[i]
                datum.value = datum.count / ratio
              }
            }

            $scope.relativeMax = $scope.max / ratio
          }

          $scope.$watch(
            function () {
              return $scope.values ? $scope.values : null
            },
            function (newVal) {
              if (newVal != null) {
                recalculateData()
              }
            }
          )

          $scope.$watch('max', function (newVal, oldVal) {
            if (newVal && newVal != oldVal) {
              recalculateData()
            }
          })
        }
      }
    })
})()
